export default __webpack_public_path__ + "static/media/darkModeLogin.f0522057.png";